import { Component, OnInit } from '@angular/core';
import { Dialog } from '../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { SessionService } from '../session/session.service';
import { Execution } from './execution';
import { RecordLink } from '../record-link/record-link';
import { Document } from '../document/document';

const DROPBOX_SCRIPT_ID = 'dropboxjs';
const DROPBOX_SCRIPT_URL = 'https://www.dropbox.com/static/api/2/dropins.js';

/**
 * Dossier filter dialog
 */
@Component({
  templateUrl: './download-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-306px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class DownloadDialogComponent implements Dialog, OnInit {
  state = 'closed';

  execution: Execution
  link: RecordLink
  document: Document

  localUrl: string
  dropboxUrl: string
  filename: string

  constructor(private sessionService: SessionService) {}
  
  onClose: () => void

  ngOnInit() {
    this.localUrl = `/files/generate/${this.execution.id}`;

    if(this.link) {
      this.localUrl += `/${this.link.id}/${this.document.id}`;
      this.filename = `${this.document.name}.docx`;
    }
    else {
      this.filename = 'documents.zip';
    }

    this.addDropboxScript();

    // Get a new access token
    this.sessionService.access_token()
    .subscribe((token) => {
      this.dropboxUrl = `${window.location.origin}${this.localUrl}?access_token=${token}`;
    }, (err) => {
      console.error(err);
    });
  }

  close() {
    this.onClose();
  }
  
  hotkeys(event: KeyboardEvent){

    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
    }
  }

  addDropboxScript() {
    let script = document.getElementById(DROPBOX_SCRIPT_ID);

    if(!script) {
      script = document.createElement('script');

      script.setAttribute('id', DROPBOX_SCRIPT_ID);
      script.setAttribute('data-app-key', process.env.DROPBOX_APP_KEY);
      script.setAttribute('src', DROPBOX_SCRIPT_URL);

      document.body.appendChild(script);
    }
  }

  downloadToDropbox() {
    if(window['Dropbox']) {
      window['Dropbox'].save(this.dropboxUrl, this.filename);
    }
  }
}

